import Form from './containers/Form';

export default () => <Form />;
